export default "__VITE_ASSET__DUMoRQdY__"